export default __webpack_public_path__ + "static/media/fo.aa2b58f9.png";